import {Injectable} from '@angular/core';
import {MarkdownService} from 'ngx-markdown';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OpenDocumentationMdService {

  constructor(private markdownService: MarkdownService,
              private httpClient: HttpClient) {

  }
  openDocLandingpage() {
      this.openDoc('assets/docs/embeded/landingpage-fr.md');
  }

  openDoc(path: string) {
      this.httpClient.get(path, { responseType: 'text' })
          .subscribe(async data => {
              // ngx-markdown v17 may return either `string` or `Promise<string>` from `parse()`.
              // Convert it to a concrete string before building the Blob.
              const html = await this.markdownService.parse(data);

              const winUrl = URL.createObjectURL(
                  new Blob([html], { type: 'text/html' })
              );
              window.open(
                  winUrl,
                  'win',
                  `width=800,height=400,screenX=200,screenY=200`
              );
          });
  }
}
